import { useEffect } from 'react';
import { canonicalAuthUrl } from '@/lib/platform-login';

/**
 * The ERP no longer renders any auth page (ADR-004) — the platform app owns the
 * canonical sign-in at zafroi.com/login (and /login/forgot|reset|invite|mfa).
 * These routes still exist in the ERP only to forward stray hits / bookmarked
 * links to the canonical app, preserving the path + token query.
 *
 * `to` overrides the forwarded path (e.g. legacy /accept-invite → /login/invite);
 * otherwise the current pathname is forwarded 1:1.
 */
export function CanonicalAuthBounce({ to }: { to?: string }) {
  useEffect(() => {
    const path = to ?? window.location.pathname;
    window.location.replace(canonicalAuthUrl(path + window.location.search));
  }, [to]);
  return null;
}
